<template>
  <div id="About">
    <a-card class="cardStyle">
      <p class="title">公司简介</p>
      <p
        class="info"
      >上海瑞酷数码科技有限公司（简称：瑞酷）成立于2011年，是专业的手机游戏内容提供商(CP)。公司团队由一大批具有丰富经验且坚持理念、坚持梦想的游戏人组成，核心开发团队成员都具有丰富的端游、页游和手游开发及运营经历，并且已经在移动游戏领域取得深厚的技术和产品积累。</p>
      <p class="title">成长经历</p>
      <!-- 时间轴 -->
      <a-Time-Line mode="alternate" class="timeLine">
        <a-Time-Line-Item v-for="(item,index) in timeLineInfo" :key="index">{{item}}</a-Time-Line-Item>
      </a-Time-Line>
      <p class="title">瑞酷愿景</p>
      <p class="info">瑞酷坚持“专业·专注”的产品理念，通过打造有公司特质的优秀产品成为有国际影响力的游戏内容提供商。</p> 
    </a-card>
  </div>
</template>
<script>
import { Timeline, Card } from "ant-design-vue";
export default {
  name: "About",
  data() {
    return {
      timeLineInfo: [
        "2011年5月成立",
        "2011年10月休闲游戏《大家来找碴HD》系列iPad版在苹果AppStore上线",
        "2011年11月《大家来找碴HD》位居中国区AppStore排行榜第一名",
        "2012年6月起《欢乐宠物店》iOS日语版本（私のペットショップ ）在日本区上线运营 2012年8月起《欢乐宠物店》iOS中文版在中港台地区上线运营",
        "2013年1月起《欢乐宠物店》iOS英文版（Pets World）在欧美地区上线运营",
        "2013年3月起动《腹黑Q神传》大型MMORPG 手机网游项目",
        "2015年4月《雅典娜物语》签约游久游戏为中国区独家代理发行商"
      ]
    };
  },
  components: {
    aTimeLine: Timeline,
    aTimeLineItem: Timeline.Item,
    aCard: Card
  }
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';

#About {
  width: 100%;
  color: #101010; 
  .cardStyle{
    cardStyle();
  } 
  .title {
    font-size: 24px;
  }

  .timeLine {
    color: #101010;
  } 
}
@media screen and (max-width:650px){
  #About{
    padding:0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About/About.vue